import React, { useContext, useEffect, useState } from 'react'
import { IoIosAddCircleOutline } from 'react-icons/io'
import { useParams } from 'react-router-dom'
import AlertContext from '../../../../Context/Alert/AlertContext';
import { BaseURL } from '../../../../Files/BaseURL';
import { formatDateForInput } from '../../../../Files/UseFunction';
import axios from "axios";
import {FaFileAlt, FaTimes} from "react-icons/fa";
import {useNavigate} from "react-router-dom";

const RequestOverview = () => {

    const { id } = useParams();

    const [OfferDetails, setOfferDetails] = useState(null)
    const [message, setMessage] = useState('')
    const [amount, setAmount] = useState('')
    const [responseDate, setResponseDate] = useState('')
    const [attachFiles, setAttachFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const alertcontext = useContext(AlertContext);
    const { showAlert } = alertcontext;


    const FetchDetails = async () => {
        try {
            const authToken = localStorage.getItem("p@token");
            const response = await fetch(`${BaseURL}/api/requestjob/getJobDetails/${id}`, {
                method: 'GET',
                headers: {
                    'auth-token': authToken,
                },
            })
            const data = await response.json()
            if (response.ok) {
                setOfferDetails(data.job)
            } else {
                showAlert(data.message, 'danger')
            }
        } catch {
            showAlert("Internal Server Error", 'danger')
        }
    }

    const validation = () => {
        if (!amount || !responseDate || !message) {
            showAlert('Please fill in all fields', 'danger')
            return false;
        }
        return true;
    }

    const onSubmit = async () => {

        if (!validation()) {
            return;
        }

        const formData = new FormData();
        formData.append("amount", amount);
        formData.append("jobId", id);
        formData.append("message", message);
        formData.append("responseDate", responseDate);

        attachFiles.forEach((attachFile) => {
            formData.append("Attachfile", attachFile);
            formData.append("OrignalNames", attachFile.name);
        });

        setLoading(true);

        try {
            const response = await axios.post(`${BaseURL}/api/requestjob/createResponse`, formData, {
                headers: {
                    'auth-token': localStorage.getItem('p@token'),
                    'Content-Type': 'multipart/form-data'
                }
            })

            if (response.status === 200) {
                showAlert('Response sent successfully', 'success')
                setLoading(false);
                navigate('/user-dashboard/offers/job-requests');
                return;
            } else {
                showAlert('Something went wrong', 'danger')
                setLoading(false);
            }
        }catch (error) {
            showAlert('Something went wrong', 'danger')
        }

    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setAttachFiles((prevFiles) => [...prevFiles, file]);
    };

    const removeFile = (index) => {
        setAttachFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    useEffect(() => {
        if (id) {
            FetchDetails()
        }
    }, [id])


    return (
        <div className='flex items-center font-pop flex-col'>
            <div className="mx-6 bg-white rounded-2xl py-6 px-6 my-6 w-fit flex flex-col gap-4">
                <h1 className='font-semibold text-xl text-center'>Request</h1>
                <div className="flex flex-row gap-2 items-center">
                    <img src={OfferDetails?.User?.ProfilePhoto} alt="" className='w-12 h-12' />
                    <div className="flex flex-col">
                        <div className='text-xs md:text-sm text-gray-400 flex items-center gap-1'>
                            <img src="../../../../Assets/Prop/badge.png" alt="" className='w-4 h-4' />
                            Level 1
                        </div>
                        <h2 className='text-sm md:text-base font-semibold'>{OfferDetails?.User?.FirstName} {OfferDetails?.User?.LastName}</h2>
                    </div>
                </div>
                <div className="flex flex-col-reverse md:flex-row gap-6">
                    <div className="basis-[50%] flex flex-col gap-2">
                        {OfferDetails?.Attachfile?.map((item, index) => (
                            <a href={item?.src} download={true} target='_blank' key={index}>
                                <div className="flex flex-row gap-2 items-center">
                                    <img src="../../../../Assets/Prop/pdf.png" alt="" className='w-8 h-8' />
                                    <h2 className='font-semibold'>{item.OrignalName}</h2>
                                </div>
                            </a>
                        ))}
                    </div>
                    <div className="flex flex-col gap-4 basis-[50%]">
                        <div className="flex font-pop flex-col gap-2">
                            <p className='text-base text-lightGrey font-light'>Service:</p>
                            <h3 className='text-lg font-medium'>{OfferDetails?.Title}</h3>
                        </div>
                        <div className="flex font-pop flex-col gap-2">
                            <p className='text-base text-lightGrey font-light'>Delivery time:</p>
                            <h3 className='text-lg font-medium'>{formatDateForInput(OfferDetails?.DeliveryDate)}</h3>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <div className="flex flex-col md:flex-row gap-2">
                        <input
                            type="number"
                            id="price"
                            name="price"
                            placeholder='Your Price'
                            className="w-full px-6 border-2 border-transparent font-pop text-base rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
                            onChange={(e) => setAmount(e.target.value)}
                        />
                        <input
                            type="date"
                            id="date"
                            name="date"
                            placeholder='Your delivery time'
                            className="w-full px-6 border-2 border-transparent font-pop text-base rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
                            onChange={(e) => setResponseDate(e.target.value)}
                        />
                    </div>
                    <textarea
                        name="message"
                        placeholder='Message to the buyer'
                        id="message"
                        cols="30"
                        rows="4"
                        className="w-full px-6 border-2 border-transparent font-pop text-base rounded-2xl  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
                        // onChange={(e) => setMessage(e.target.value)}
                        onChange={(e) => setMessage(e.target.value.slice(0, 250))}  maxLength={250}  
                    >
                    </textarea>
                    <div className="flex items-center justify-center w-full">
                        <label for="dropzone-file"
                               className="flex flex-col items-center justify-center w-full border-2 border-primarygreen border-dashed rounded-lg cursor-pointer bg-transparent dark:hover:bg-bray-800 dark:bg-gray-300 hover:bg-gray-100 dark:border-gray-300 dark:hover:border-gray-200 dark:hover:bg-gray-300">
                            <div
                                className="flex flex-row gap-4 items-center justify-center py-3 text-primarygreen font-pop">
                                <IoIosAddCircleOutline className='text-2xl'/>
                                <p className="text-base">Attach file</p>
                            </div>
                            <input id="dropzone-file" type="file" className="hidden"
                                   onChange={(e) => handleFileChange(e)}/>
                        </label>
                    </div>

                    <div className="flex gap-2 flex-wrap">
                        {attachFiles?.map((item, index) => (
                            <div
                                className="border-2 border-primarygreen rounded-lg py-2 px-2 flex gap-1 items-center"
                                key={index}
                            >
                                <FaFileAlt/>
                                <p>{item?.name}</p>
                                <FaTimes onClick={() => removeFile(index)}/>
                            </div>
                        ))}
                    </div>

                    <button
                        className="my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-medium hover:text-black font-pop text-sm md:text-lg py-1 md:py-3 border border-black-500 hover:border-green-500 rounded-full  text-white"
                        onClick={onSubmit} disabled={loading}>
                        { loading ? "Loading" :  "Send offer"}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default RequestOverview